(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var layout = function layout() {
  //Hamburger expand in mobile and desktop
  var hamburgers = document.querySelectorAll('.ham');
  var mob = document.querySelectorAll('.mob-ham');
  var desk = document.querySelectorAll('.desk');
  var desktop = document.querySelectorAll('.desktop-ham');
  var loginPopup = document.querySelectorAll('.login-signup');
  var nav = document.querySelector('nav');
  var createButton = document.querySelector('.create-btn');
  var mobOpen = false;
  var deskOpen = false;
  window.addEventListener('error', function (errorEvent) {
    var errorDetails = {
      message: errorEvent.message,
      url: errorEvent.filename,
      line: errorEvent.lineno,
      column: errorEvent.colno,
      stack: errorEvent.error.stack
    };

    // Send error details to Laravel backend
    fetch("".concat(URL_BASE, "/api/log/javascript-error"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(errorDetails)
    });
  });
  var toggleVisibility = function toggleVisibility() {
    hamburgers.forEach(function (item) {
      item.classList.toggle('hide');
    });
    loginPopup.forEach(function (item) {
      item.classList.toggle('hide');
    });
    mob.forEach(function (item) {
      if (mobOpen) {
        item.classList.remove('show');
        item.classList.add('hide-tgl');
        item.addEventListener('animationend', function () {
          item.style.display = 'none';
        }, {
          once: true
        });
      } else {
        item.classList.remove('hide-tgl');
        item.classList.add('show');
        item.style.display = 'block';
      }
      mobOpen = !mobOpen;
    });
  };
  var toggleVisibile = function toggleVisibile() {
    desktop.forEach(function (item) {
      if (deskOpen) {
        item.classList.remove('show');
        item.classList.add('hide-tgl');
        item.addEventListener('animationend', function () {
          item.style.display = 'none';
          nav.style.width = 'auto';
        }, {
          once: true
        });
      } else {
        item.classList.remove('hide-tgl');
        item.classList.add('show');
        item.style.display = 'block';
        nav.style.width = '300px';
      }
      deskOpen = !deskOpen;
    });
  };
  var hideVisible = function hideVisible() {
    if (deskOpen) {
      desktop.forEach(function (item) {
        item.classList.remove('show');
        item.classList.add('hide-tgl');
        item.addEventListener('animationend', function () {
          item.style.display = 'none';
          nav.style.width = 'auto';
        }, {
          once: true
        });
      });
      deskOpen = false;
    }
    if (mobOpen) {
      mob.forEach(function (item) {
        item.classList.add('hide-tgl');
      });
      hamburgers.forEach(function (item) {
        item.classList.toggle('hide');
      });
      mobOpen = false;
    }
  };

  // Add click event listener to each hamburger element
  hamburgers.forEach(function (ele) {
    ele.addEventListener('click', toggleVisibility);
  });
  desk.forEach(function (ele) {
    ele.addEventListener('click', toggleVisibile);
  });

  // Add click event listener for hide
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.desk') && !event.target.closest('.desktop-ham') && deskOpen) {
      hideVisible();
    }
    if (!event.target.closest('.ham') && !event.target.closest('.mob-ham') && mobOpen) {
      hideVisible();
    }
  });

  // web app install
  var appInstall = document.getElementById('appInstall');
  var deferredPrompt;
  window.addEventListener('beforeinstallprompt', function (e) {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Optionally, send analytics event that PWA install promo was shown.
    console.log("'beforeinstallprompt' event was fired.");
  });
  function showInstallPrompt() {
    return _showInstallPrompt.apply(this, arguments);
  }
  function _showInstallPrompt() {
    _showInstallPrompt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$deferredPrompt, outcome;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (deferredPrompt) {
              _context2.next = 3;
              break;
            }
            alert("Installed App Already!!!");
            return _context2.abrupt("return", false);
          case 3:
            deferredPrompt.prompt();

            // Wait for the user to respond to the prompt
            _context2.next = 6;
            return deferredPrompt.userChoice;
          case 6:
            _yield$deferredPrompt = _context2.sent;
            outcome = _yield$deferredPrompt.outcome;
            // Optionally, send analytics event with outcome of user choice
            console.log("User response to the install prompt: ".concat(outcome));

            // We've used the prompt, and can't use it again, throw it away
            deferredPrompt = null;
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _showInstallPrompt.apply(this, arguments);
  }
  if (appInstall) {
    appInstall.addEventListener('click', showInstallPrompt);
  }

  //privacy expand
  var priExpand = document.querySelectorAll('.pri-exp');
  var privacy = document.querySelectorAll('.privacy');
  var toggle = function toggle() {
    privacy.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  priExpand.forEach(function (ele) {
    ele.addEventListener('click', toggle);
  });

  //About expand
  var abtExpand = document.querySelectorAll('.abt-exp');
  var about = document.querySelectorAll('.about');
  var aboutToggle = function aboutToggle() {
    about.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  abtExpand.forEach(function (ele) {
    ele.addEventListener('click', aboutToggle);
  });

  //Ticket expand
  var ticketExpand = document.querySelectorAll('.ticket-exp');
  var ticket = document.querySelectorAll('.ticket');
  var ticketToggle = function ticketToggle() {
    ticket.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  ticketExpand.forEach(function (ele) {
    ele.addEventListener('click', ticketToggle);
  });

  //payment expand
  var payExpand = document.querySelectorAll('.pay-exp');
  var pay = document.querySelectorAll('.pay');
  var hideAndVisible = function hideAndVisible() {
    pay.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  payExpand.forEach(function (ele) {
    ele.addEventListener('click', hideAndVisible);
  });
  var closeModal = function closeModal(ele) {
    var element = document.querySelector("#".concat(ele));
    if (!element) {
      return false;
    }
    var form = element.querySelector('form');
    if (form) {
      form.reset();
    }
    element.removeAttribute('id-open');
    element.style.display = 'none';
    document.getElementById('overlay').style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';
  };
  var closeModalHandler = function closeModalHandler() {
    document.querySelectorAll('.modal-container').forEach(function (ele) {
      var form = ele.querySelector('form');
      if (form) {
        form.reset();
      }
      ele.removeAttribute('id-open');
      ele.style.display = 'none';

      // Restore href attributes in links inside the modal
      var links = ele.querySelectorAll('a');
      links.forEach(function (link) {
        var originalHref = link.getAttribute('href');
        if (originalHref && originalHref.includes("/post/")) {
          var baseHref = originalHref.split('?')[0];
          link.setAttribute('href', baseHref);
        }
      });
    });

    // Adjust copy_link value to remove /post/${responseId}
    var copy_link = document.querySelector('#copy_post_link');
    if (copy_link) {
      copy_link.value = '';
    }
    document.getElementById('overlay').style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';

    // Check if createButton has a disabled attribute and remove it
    if (createButton && createButton.hasAttribute('disabled')) {
      createButton.removeAttribute('disabled');
      createButton.classList.remove('disabled');
    }
  };
  var overlays = document.getElementById('overlay');
  if (overlays) {
    overlays.addEventListener('click', closeModalHandler);
  }
  document.querySelectorAll('.modal-container, .modal-container .close, .modal-container .cancel').forEach(function (element) {
    element.addEventListener('click', function (e) {
      if (e.currentTarget !== e.target) {
        return;
      }
      e.preventDefault();
      closeModalHandler();
    });
  });
  var showFormError = function showFormError(errors, parentEl) {
    var error = '';
    for (var key in errors) {
      if (errors.hasOwnProperty(key)) {
        error += '<li>' + errors[key] + '</li>';
      }
    }
    parentEl.querySelector('.showFormErrors').innerHTML = error;
    parentEl.querySelector('.formError').style.setProperty('display', 'block', 'important');
  };
  var openModal = function openModal(id, event) {
    var overlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var ele = document.getElementById(id);
    if (!ele) {
      return false;
    }
    ele.setAttribute('id-open', true);
    var wallet = ele.querySelector('#walletAmount');
    if (wallet) {
      wallet.innerHTML = walletAmount;
    }
    ele.style.display = 'flex';
    if (overlay) {
      document.getElementById('overlay').style.display = 'block';
      document.querySelector('body').style.overflow = 'hidden';
    }
    // if (window.innerWidth >=768) {
    //     const x = event.clientX;
    //     const y = event.clientY;

    //     ele.style.left = x + 'px';
    //     ele.style.top = y + 'px';
    //     // ele.style.display = 'block';

    //     console.log(event.clientX)
    //     console.log(event.clientY)
    // }
  };
  var copyToClipboard = function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      // Use the Clipboard API if available and in a secure context
      navigator.clipboard.writeText(text).then(function () {})["catch"](function (err) {
        console.error('Failed to copy text: ', err);
      });
    } else {
      // Fallback to the older method
      var textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log('Text copied to clipboard');
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
      document.body.removeChild(textarea);
    }
  };
  function isInViewport(element, offset) {
    var rect = element.getBoundingClientRect();
    return rect.top >= 0 - offset && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
  function handleScroll() {
    var element = document.querySelector('.loadmore');
    if (!element) return;
    var dataload = element.getAttribute('data-load');
    if (dataload === "true" && isInViewport(element, 800)) {
      element.setAttribute('data-load', "false");
      element.click();
    }
  }
  document.addEventListener('scroll', handleScroll);
  var main = document.querySelector('main');
  if (main) {
    main.addEventListener('scroll', handleScroll);
  }
  var replaceSrc = function replaceSrc(element, isAdded) {
    if (element.tagName.toLowerCase() === 'img') {
      var currentSrc = element.getAttribute('src');
      var newSrc = isAdded ? currentSrc.replace('.svg', '-filled.svg') : currentSrc.replace('-filled.svg', '.svg');
      element.setAttribute('src', newSrc);
    }
  };

  //loadmore notifications
  var loadMores = function loadMores(e) {
    var loadMoreButton = e.target;
    var mainClassName = loadMoreButton.getAttribute('data-main');
    var subClass = loadMoreButton.getAttribute('data-sub');
    var mainElements = document.querySelectorAll(mainClassName);
    var lastMainElement = mainElements[mainElements.length - 1];
    var subElements = lastMainElement.querySelectorAll(subClass);
    var totalSubElements = 0;

    // Count all sub-elements when either 'firstFeed' or 'pinnedPost' is present in updates
    mainElements.forEach(function (mainElement) {
      totalSubElements += mainElement.querySelectorAll(subClass).length;
    });

    // set the skip value based on the counts
    var skip = totalSubElements > subElements.length ? totalSubElements : subElements.length;
    var href = loadMoreButton.getAttribute('data-href') + '&skip=' + skip;

    // get the total in href
    var totalMatch = href.match(/total=(\d+)/);
    var total = totalMatch ? parseInt(totalMatch[1], 10) : null;
    if (loadMoreButton) {
      fetch(href, {
        method: 'GET',
        headers: {
          'Accept': 'application/xml',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return response.text();
      }).then(function (data) {
        if (!data) {
          loadMoreButton.classList.add('disabled', 'hide');
        }
        if (data && data !== "session_timeout") {
          var tempContainer = document.createElement('div');
          tempContainer.innerHTML = data;
          if (tempContainer.firstChild && tempContainer.firstChild.nodeName && tempContainer.firstChild.nodeName.toLowerCase() === 'div') {
            while (tempContainer.firstChild) {
              lastMainElement.appendChild(tempContainer.firstChild);
            }
            skip = lastMainElement.querySelectorAll(subClass).length;
            loadMore.setAttribute('data-load', "true");
          } else {
            loadMore.parentNode.removeChild(loadMore);
          }
          if (total <= skip) {
            loadMore.parentNode.removeChild(loadMore);
          }
        }
      })["catch"](function (error) {
        console.error('Error fetching data:', error);
      });
    }
  };
  var loadMore = document.querySelector('.loadmore');
  if (loadMore) {
    loadMore.addEventListener('click', loadMores);
  }

  //unfollow handler
  var unfollowHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var unfollowBtn, creatorId, profFollowIcon, response, data, allButtons, index, errorData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            unfollowBtn = document.querySelector('.unfollow-btn');
            creatorId = unfollowBtn.getAttribute("data-user");
            profFollowIcon = document.querySelector('.prof-follow-icon');
            _context.prev = 4;
            _context.next = 7;
            return fetch("".concat(URL_BASE, "/follow"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
              body: JSON.stringify({
                creator_id: creatorId,
                follow: "0"
              })
            });
          case 7:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 20;
              break;
            }
            _context.next = 11;
            return response.json();
          case 11:
            data = _context.sent;
            document.querySelector('#jsModal .header').innerHTML = 'Success!!';
            document.querySelector('#jsModal .body').innerHTML = 'You unfollowed this creator';
            // Update all buttons with the same creator ID
            allButtons = document.querySelectorAll(".f-".concat(creatorId));
            allButtons.forEach(function (btn) {
              btn.textContent = 'Follow';
              btn.classList.add('pri-btn');
              btn.classList.remove('sel-btn');
            });
            index = fc.indexOf(parseInt(creatorId));
            if (index !== -1) {
              fc.splice(index, 1);
              if (profFollowIcon) {
                profFollowIcon.classList.toggle('hide');
              }
            }
            _context.next = 25;
            break;
          case 20:
            _context.next = 22;
            return response.json();
          case 22:
            errorData = _context.sent;
            document.querySelector('#jsModal .header').innerHTML = 'Failed!!';
            document.querySelector('#jsModal .body').innerHTML = '<br><br>Failed to unfollowed this creator';
          case 25:
            window.closeModal('kebabListModal');
            window.closeModal('messageListModal');
            window.closeModal('notificationListModal', e);
            window.openModal('jsModal', e);
            _context.next = 34;
            break;
          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](4);
            console.log(_context.t0);
          case 34:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 31]]);
    }));
    return function unfollowHandler(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  window['showFormError'] = showFormError;
  window['openModal'] = openModal;
  window['closeModal'] = closeModal;
  window['copyToClipboard'] = copyToClipboard;
  window['replaceSrc'] = replaceSrc;
  window['loadmores'] = loadMores;
  window['unfollowHandler'] = unfollowHandler;
  if (SOCKET_URL) {
    window['socket'] = io.connect(SOCKET_URL, {
      withCredentials: true
    });
    window['socket'].on('connect', function () {
      var activeStatusOnline = document.querySelectorAll(".active-status-online");
      if (activeStatusOnline.length > 0) {
        var userIds = Array.from(activeStatusOnline).map(function (element) {
          return element.getAttribute('data-user-id');
        });
        socket.emit('usersActiveStatus', userIds, function (response) {
          console.log("Server response for usersActiveStatus:", response);
        });
      }
    });
    window['socket'].on('error', function (error) {
      console.error('Socket error:', error);
    });
  }
  // Cookies
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim(); // Trim leading spaces
      if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
  }
  var cookieOverlay = document.getElementById('overlay-cookie');
  var overlay = document.getElementById('overlay');
  var body = document.querySelector('body');
  function showOverlay() {
    if (alertAdultModal || cookieConsentModal) {
      cookieOverlay.style.display = 'block';
      overlay.style.display = 'none';
      body.classList.add('overflow-hidden');
    }
  }
  function closeOverlay() {
    if (cookieConsentModal) {
      cookieOverlay.style.display = 'none';
      body.classList.remove('overflow-hidden');
    }
  }
  var alertAdultModal = document.querySelector('#alertAdult');
  var btnAlertAdult = document.querySelector('#btnAlertAdult');
  if (alert_adult && !getCookie('alertAdult')) {
    window.openModal('alertAdult');
    overlay.style.display = 'none';
    showOverlay();
  }
  if (btnAlertAdult) {
    btnAlertAdult.addEventListener('click', function () {
      setCookie('alertAdult', true, 365);
      if (alertAdultModal && getCookie('alertAdult')) {
        window.closeModal('alertAdult');
        closeOverlay();
      }
    });
  }
  var cookieConsentModal = document.querySelector('#cookieConsentModal');
  var btnCloseCookieConsent = document.querySelector('#btnCloseCookieConsent');
  if (cookie_consent && !getCookie('cookiePolicy')) {
    window.openModal('cookieConsentModal');
    overlay.style.display = 'none';
  }
  if (btnCloseCookieConsent) {
    btnCloseCookieConsent.addEventListener('click', function () {
      setCookie('cookiePolicy', true, 365);
      if (cookieConsentModal && getCookie('cookiePolicy')) {
        window.closeModal('cookieConsentModal');
      }
    });
  }

  //share the live event to the BroadCast message
  var broadcastLink = document.getElementById('broadcastLink');
  var messageTextarea = document.querySelector('.broadcast-msg');
  var replyButton = document.getElementById('button-reply-msg');
  if (broadcastLink) {
    broadcastLink.addEventListener('click', function (event) {
      event.preventDefault();
      var liveMessage = broadcastLink.getAttribute('data-message');
      window.location.href = broadcastLink.href + '?message=' + encodeURIComponent(liveMessage);
    });
  }
  if (messageTextarea) {
    var urlParams = new URLSearchParams(window.location.search);
    var message = decodeURIComponent(urlParams.get('message') || ''); //If qrystring message is null, empty string will be assigned
    if (message.trim()) {
      replyButton.classList.remove('disabled');
      replyButton.style.opacity = "1";
      messageTextarea.value = message;
    }
  }
  var socket = window.socket;
  if (socket) {
    //When user is offline or login issue during Login-validation in Socketcontroller of socket server, Redirect to Login page
    socket.on('login-error', function (data) {
      console.log('Socket Login-error');
    });
  }

  // Live Streaming Time Conversion
  var liveTimeElems = document.querySelectorAll('.jsliveTime');
  if (liveTimeElems) {
    liveTimeElems.forEach(function (liveTimeEle) {
      if (liveTimeEle && liveTimeEle.innerHTML) {
        var _liveTimeEle$innerHTM = liveTimeEle.innerHTML.split(' '),
          _liveTimeEle$innerHTM2 = _slicedToArray(_liveTimeEle$innerHTM, 2),
          scheduleDate = _liveTimeEle$innerHTM2[0],
          scheduleTime = _liveTimeEle$innerHTM2[1];
        if (scheduleTime) {
          var _scheduleTime$split = scheduleTime.split(':'),
            _scheduleTime$split2 = _slicedToArray(_scheduleTime$split, 3),
            scHour = _scheduleTime$split2[0],
            scMin = _scheduleTime$split2[1],
            scSec = _scheduleTime$split2[2];
          var d = new Date();
          d.setUTCHours(scHour, scMin, scSec, 0);

          // Format the local time in 12-hour format without seconds
          var localTimeString = d.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          });

          // Update the innerHTML with the local time string, replacing am/pm with AM/PM
          liveTimeEle.innerHTML = localTimeString.replace('am', 'AM').replace('pm', 'PM');
        }
      }
    });
  }

  // If the creator refresh the page, then display the active vcModal
  var videoCallAlertModal = document.getElementById('videoCallAlertModal');
  if (videoCallAlertModal) {
    // Get values from view services provider
    var creatorId = videoCallAlertModal.querySelector('#crId').value;
    var userId = videoCallAlertModal.querySelector('#userId').value;
    var authUserId = videoCallAlertModal.querySelector('#authUser').value;
    var vcRoomId = videoCallAlertModal.querySelector('#roomId').value;
    var answerBtn = videoCallAlertModal.querySelector('#answer-btn');
    var rejectBtn = videoCallAlertModal.querySelector('#reject-btn');
    var snoozeBtn = videoCallAlertModal.querySelector('#snooze-btn');
    var snoozeDropdown = document.getElementById('snooze-dropdown');
    var snoozeDurations = document.querySelectorAll('.snooze-duration');
    var offVcAlertSound = document.getElementById('stopPlayBack').value;
    var showNotifyAlert = videoCallAlertModal.querySelector('#notifyAlert').value;
    window.addEventListener("load", function () {
      // If the video call is ongoing and the authenticated user is the creator
      if (creatorId == authUserId && vcRoomId && showNotifyAlert === 'yes') {
        videoCallAlertModal.classList.remove('hide'); // Show the modal
        // If the user is snooze the video call then stop the ringtone sound
        if (offVcAlertSound == 1) {
          snoozeBtn.classList.add('hide');
        }
      }
    });
    if (answerBtn && rejectBtn && snoozeBtn) {
      // Handle answer button click
      answerBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // Get values from data attribute
        var roomId = videoCallAlertModal.getAttribute('data-room-id');
        roomId = roomId || vcRoomId;
        var url = "".concat(URL_BASE, "/video/call/").concat(authUserId, "/").concat(roomId);
        console.log('Answer button clicked');
        videoCallAlertModal.classList.add('hide');
        window.location.href = url;
      });

      // Handle reject button click
      rejectBtn.addEventListener('click', function () {
        // Get values from data attribute
        var callerId = videoCallAlertModal.getAttribute('data-caller-id');
        var roomId = videoCallAlertModal.getAttribute('data-room-id');
        callerId = callerId || userId;
        roomId = roomId || vcRoomId;
        console.log('Reject button clicked');
        socket.emit('reject-call', {
          userId: callerId,
          recipientId: creatorId,
          roomId: roomId
        });
        videoCallAlertModal.classList.add('hide');
      });

      // Toggle dropdown visibility on button click
      if (snoozeBtn) {
        snoozeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          // Toggle the 'hide' class
          snoozeDropdown.classList.toggle('hide');
        });
      }

      // Close the dropdown if clicking outside
      document.addEventListener('click', function (e) {
        if (!snoozeBtn.contains(e.target) && !snoozeDropdown.contains(e.target)) {
          snoozeDropdown.classList.add('hide');
        }
      });

      // Handle snooze button click
      snoozeDurations.forEach(function (snoozeDuration) {
        snoozeDuration.addEventListener('click', function () {
          // Get values from data attribute
          var roomId = videoCallAlertModal.getAttribute('data-room-id');
          var snoozeTime = snoozeDuration.dataset.duration;
          roomId = roomId || vcRoomId;
          console.log('snooze button clicked');
          fetch("/videocall/snooze/".concat(creatorId, "/").concat(roomId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
              snoozeTime: snoozeTime
            })
          }).then(function (response) {
            return response.json();
          }).then(function (data) {
            if (data) {
              socket.emit('snooze-call', {
                recipientId: creatorId
              });
            }
          })["catch"](function (error) {
            console.error('Error fetching data:', error);
          })["finally"](function () {
            snoozeDropdown.classList.add('hide');
          });
        });
      });
    }
  }
  var audioContext = new (window.AudioContext || window.webkitAudioContext)();
  var source;
  if (socket) {
    // Function to close the videoCallAlertModal if the recipientId matches
    var closeVideoCallAlertModal = function closeVideoCallAlertModal(recipientId) {
      var videoCallAlertModal = document.getElementById('videoCallAlertModal');
      if (videoCallAlertModal) {
        var _authUserId2 = videoCallAlertModal.querySelector('#crId').value;
        if (_authUserId2 == recipientId) {
          videoCallAlertModal.classList.add('hide');
        }
        // const receiverTone = videoCallAlertModal.querySelector('#receiver-tone');
        // receiverTone.pause();
        // receiverTone.currentTime = 0;
        if (source) {
          source.stop(); // Stop playback
          source = null; // Clear the source to prevent re-stopping
        }
      }
    }; // If creator didn't accept the call
    socket.on('receive-call', function (data) {
      if (data) {
        console.log('Incoming call from:', data.callerId);
        var _videoCallAlertModal = document.getElementById('videoCallAlertModal');
        _videoCallAlertModal.setAttribute('data-room-id', data.roomId);
        _videoCallAlertModal.setAttribute('data-caller-id', data.callerId);
        var userDetails = data.userDetails;
        var _offVcAlertSound = data.stopPlayback;
        var videoCallAlertOff = data.videoCallAlertOff;
        var _snoozeBtn = _videoCallAlertModal.querySelector('#snooze-btn');
        if (_videoCallAlertModal && !videoCallAlertOff) {
          // const receiverTone = videoCallAlertModal.querySelector('#receiver-tone');
          // receiverTone.pause();
          // receiverTone.currentTime = 0;
          // const ringtone = new Audio(receiverTone);
          // ringtone.loop = true;
          // ringtone.play();
          if (!source && !_offVcAlertSound) {
            fetch(receiverTone).then(function (response) {
              return response.arrayBuffer();
            }).then(function (buffer) {
              return audioContext.decodeAudioData(buffer);
            }).then(function (decodedData) {
              source = audioContext.createBufferSource();
              source.buffer = decodedData;
              source.loop = true;
              source.connect(audioContext.destination);
              source.start(0);
            })["catch"](function (error) {
              return console.log("Audio playback error:", error);
            });
          }
          // If the creator is snooze the video call then stop the ringtone sound
          if (_offVcAlertSound && _snoozeBtn) {
            _snoozeBtn.classList.add('hide');
          }
          _videoCallAlertModal.querySelector('#roomId').value = data.roomId;
          _videoCallAlertModal.querySelector('#userId').value = data.callerId;
          _videoCallAlertModal.querySelector('.caller-name').innerHTML = userDetails.name;
          var avatarElement = document.getElementById('callerAvatar');
          avatarElement.src = avatarBasePath + userDetails.avatar;
          var _authUserId = _videoCallAlertModal.querySelector('#crId').value;
          var url = "".concat(URL_BASE, "/video/call/").concat(_authUserId, "/").concat(data.roomId);
          _videoCallAlertModal.classList.remove('hide');
        }
      }
    });
    socket.on('call-not-connected', function (data) {
      closeVideoCallAlertModal(data.recipientId);
    });

    // Listen for 'close-alert-modal' event and close the modal
    socket.on('close-alert-modal', function (data) {
      closeVideoCallAlertModal(data.recipientId);
    });
  }
};
module.exports = layout;

},{}],2:[function(require,module,exports){
"use strict";

var layout = require('./_layout.js');
var login_signup = function login_signup() {
  var error_occurred = "Error occurred!!";
  var resending_code = 'Resending code...';
  var resend_code = 'Resend code';
  var usernameInput = document.getElementById('username');

  // Function to restrict spl characters in input
  var restrictSpecialChars = function restrictSpecialChars(event) {
    var keyPressed = event.key;
    var allowedChars = /^[a-zA-Z0-9_ ]*$/;
    if (!allowedChars.test(keyPressed)) {
      event.preventDefault();
    }
  };
  if (usernameInput) {
    usernameInput.addEventListener('keypress', restrictSpecialChars);
  }
  var agreeBtn = document.querySelector('.radio');
  if (agreeBtn) {
    agreeBtn.addEventListener('change', function () {
      var hiddenInput = document.querySelector('input[name="agree_gdpr"]');
      hiddenInput.value = this.checked ? 'on' : '';
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.id === 'btnLoginRegister') {
      e.preventDefault();
      sendFormLoginRegister();
      //remove the existing displayed error msgs
      var formLoginRegister = document.getElementById('formLoginRegister');
      var verify2FaForm = document.getElementById('formVerify2fa');
      if (formLoginRegister) {
        var errorcontainer = formLoginRegister.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      }
      if (verify2FaForm) {
        var _errorcontainer = verify2FaForm.querySelector('.formError');
        _errorcontainer.style.display = 'none';
        _errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      }
    }
  });

  //login and register form submission
  var sendFormLoginRegister = function sendFormLoginRegister(event) {
    var btnLoginRegister = document.getElementById('btnLoginRegister');
    var loginRegisterForm = document.getElementById("formLoginRegister");
    btnLoginRegister.classList.add('disabled');
    btnLoginRegister.querySelector('i').classList.add('spinner');
    var formData = new FormData(loginRegisterForm);
    var loginSignupData = {};
    // Get CSRF token from meta tag
    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    var formElements = document.querySelectorAll('form input, form select, form textarea');
    formElements.forEach(function (element) {
      if (element.name) {
        loginSignupData[element.name] = element.value;
      }
    });
    fetch(loginRegisterForm.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-TOKEN': csrfToken
      },
      body: JSON.stringify(loginSignupData)
    }).then(function (response) {
      if (response.status == 419) {
        btnLoginRegister.classList.remove('disabled');
        btnLoginRegister.querySelector('i').classList.remove('spinner');
        document.querySelector('#jsModal .header').innerHTML = 'Session Expired';
        document.querySelector('#jsModal .body').innerHTML = '<br>Your session has expired. Please refresh the page to continue..';
        // Create a new button for refresh
        var refreshBtn = document.createElement('a');
        refreshBtn.setAttribute('href', 'javascript:void(0);');
        refreshBtn.innerHTML = 'Refresh';
        refreshBtn.classList.add('refresh', 'sml-btn', 'blk-btn');
        refreshBtn.addEventListener('click', function () {
          location.reload();
        });
        document.querySelector('#jsModal .body').appendChild(refreshBtn);
        window.openModal('jsModal', event);
      }
      return response.json();
    }).then(function (result) {
      if (result.actionRequired) {
        window.openModal('jsModal', event);
        return false;
      }
      if (result.success) {
        //redirected to the url return page when result is success
        if (result.url_return && !result.isModal) {
          window.location.href = result.url_return;
        }
      } else {
        if (result.errors) {
          var erMsg = result.errors;
          window.showFormError(erMsg, loginRegisterForm);
          btnLoginRegister.classList.remove('disabled');
          btnLoginRegister.querySelector('i').classList.remove('spinner');
        }
      }
    })["catch"](function (error) {
      btnLoginRegister.classList.remove('disabled');
      btnLoginRegister.querySelector('i').classList.remove('spinner');
      var erMsg = {
        error: error_occurred
      };
      window.showFormError(erMsg, loginRegisterForm);
      console.error(error);
    });
  };
  //close the modal-popup    
  document.querySelectorAll('.overlay, .modal-contanier, .modal-contanier .close').forEach(function (element) {
    element.addEventListener('click', function (e) {
      if (e.currentTarget !== e.target) {
        return;
      }
      window.closeModal('jsModal');
    });
  });

  //password hide and show
  var passwordInput = document.querySelector('#showHidePassword input');
  var eyeIcons = document.querySelectorAll('.togglePwd');
  var hideAndShow = function hideAndShow() {
    eyeIcons.forEach(function (item) {
      item.classList.toggle('hide');
    });
    passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
  };
  eyeIcons.forEach(function (ele) {
    ele.addEventListener('click', hideAndShow);
  });

  // Add event listener for press 'ENTER' to submit Login/Register form & (2FAC)
  document.addEventListener('keydown', function (event) {
    if (event.key === "Enter") {
      if (document.activeElement.id === 'onlyNumber') {
        event.preventDefault();
        document.getElementById('btn2fa').click();
      }
      if (document.activeElement.id === 'loginUserName' || document.activeElement.id === 'loginRegisterPwd') {
        event.preventDefault();
        document.getElementById('btnLoginRegister').click();
      }
    }
  });

  //Add event listener for two step verification
  var btnTwoFa = document.getElementById('btn2fa');
  if (btnTwoFa) {
    btnTwoFa.addEventListener('click', function (e) {
      e.preventDefault();
      var verify2FaForm = document.getElementById('formVerify2fa');
      //remove the existing displayed error msgs
      if (verify2FaForm) {
        var errorcontainer = verify2FaForm.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      }
      btnTwoFa.classList.add('disabled');
      btnTwoFa.querySelector('i').classList.add('spinner');
      (function () {
        var formData = new FormData(verify2FaForm);
        fetch(verify2FaForm.action, {
          method: 'POST',
          body: formData
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data.success) {
            if (data.isProfileTwoFA) {
              window.location.reload();
            } else {
              window.location.href = data.redirect;
            }
          } else {
            var erMsg = data.errors;
            window.showFormError(erMsg, verify2FaForm);
            btnTwoFa.classList.remove('disabled');
            btnTwoFa.querySelector('i').classList.remove('spinner');
          }
        })["catch"](function (error) {
          var erMsg = {
            error: error_occurred
          };
          window.showFormError(erMsg, verify2FaForm);
          console.error(error);
          btnTwoFa.classList.remove('disabled');
          btnTwoFa.querySelector('i').classList.remove('spinner');
        });
      })();
    });
  }

  //add event listener for send the resend code
  var resendCode = document.querySelector('.resend_code');
  if (resendCode) {
    resendCode.addEventListener('click', function (e) {
      e.preventDefault();
      var element = e.currentTarget;
      var resendCodeId = document.getElementById('resendCode');
      element.classList.remove('resend_code');
      element.classList.add('uline-none');
      resendCodeId.classList.add('l-grey');
      resendCodeId.innerHTML = resending_code;
      fetch(URL_BASE + '/2fa/resend', {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
          var popout = document.querySelector('.popout');
          popout.classList.remove('popout-error');
          popout.classList.add('popout-success');
          popout.innerHTML = data.text;
          popout.style.display = 'block';
          setTimeout(function () {
            popout.style.display = 'none';
          }, 5000);
          element.classList.add('resend_code');
          element.classList.remove('uline-none');
          resendCodeId.classList.remove('l-grey');
          resendCodeId.innerHTML = resend_code;
        }
      })["catch"](function (error) {
        var popout = document.querySelector('.popout');
        popout.classList.remove('popout-success');
        popout.classList.add('popout-error');
        popout.innerHTML = error_occurred;
        popout.style.display = 'block';
        setTimeout(function () {
          popout.style.display = 'none';
        }, 5000);
        element.classList.add('resend_code');
        console.error(error);
      });
    });
  }

  // Cookies
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim(); // Trim leading spaces
      if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
  }
  var cookieOverlay = document.getElementById('overlay-cookie');
  var overlay = document.getElementById('overlay');
  var body = document.querySelector('body');
  function showOverlay() {
    if (alertAdultModal || cookieConsentModal) {
      cookieOverlay.style.display = 'block';
      body.classList.add('overflow-hidden');
    }
  }
  function closeOverlay() {
    if (cookieConsentModal) {
      cookieOverlay.style.display = 'none';
      body.classList.remove('overflow-hidden');
    }
  }
  var alertAdultModal = document.querySelector('#alertAdult');
  var btnAlertAdult = document.querySelector('#btnAlertAdult');
  if (alert_adult && !getCookie('alertAdult')) {
    window.openModal('alertAdult');
    overlay.style.display = 'none';
    showOverlay();
  }
  if (btnAlertAdult) {
    btnAlertAdult.addEventListener('click', function () {
      setCookie('alertAdult', true, 365);
      if (alertAdultModal && getCookie('alertAdult')) {
        window.closeModal('alertAdult');
        closeOverlay();
      }
    });
  }
  var cookieConsentModal = document.querySelector('#cookieConsentModal');
  var btnCloseCookieConsent = document.querySelector('#btnCloseCookieConsent');
  if (cookie_consent && !getCookie('cookiePolicy')) {
    window.openModal('cookieConsentModal');
    overlay.style.display = 'none';
  }
  if (btnCloseCookieConsent) {
    btnCloseCookieConsent.addEventListener('click', function () {
      setCookie('cookiePolicy', true, 365);
      if (cookieConsentModal && getCookie('cookiePolicy')) {
        window.closeModal('cookieConsentModal');
      }
    });
  }
};
layout();
module.exports = login_signup;

},{"./_layout.js":1}],3:[function(require,module,exports){
"use strict";

var login_signup = require('../components/_login');
document.addEventListener('DOMContentLoaded', function () {
  login_signup();
});

},{"../components/_login":2}]},{},[3]);
